module.exports = __webpack_public_path__ + "img/vertical_6_6_3.decaca93.png";